module.exports = __webpack_public_path__ + "static/media/acceptance.367e254f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/acceptance.jpg
// module id = 245
// module chunks = 0